import requests from "./requests"

class ApiController{
    constructor(){
        this.request = requests
    }
}


export default new ApiController()